import {
  ReactChild,
  ReactFragment,
  ReactNode,
  ReactPortal,
  useMemo,
} from 'react';

import { Fab as MuiFab, Tooltip } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

type ActionButtonProps = {
  bgColor?: string;
  tooltip?: string;
  onClick?: () => void;
  children: (boolean | ReactChild | ReactFragment | ReactPortal) & ReactNode;
  handleClose?: () => void;
  htmlFor?: string;
};

export default function ActionButton(props: ActionButtonProps) {
  const { bgColor, tooltip, onClick, handleClose, children, htmlFor } = props;
  const theme = useTheme();
  const fabStyles = useMemo(() => {
    const background = bgColor || theme.palette.primary.main;
    const color = theme.palette.getContrastText(background);

    return { background, color };
  }, [bgColor, theme.palette]);

  return (
    <Tooltip title={tooltip || ''} placement="right">
      <MuiFab
        component="label"
        htmlFor={htmlFor}
        onClick={() => {
          onClick?.();
          handleClose?.();
        }}
        variant="circular"
        size="medium"
        style={{
          boxShadow: 'none',
          background: fabStyles.background,
          color: fabStyles.color,
        }}
      >
        {children}
      </MuiFab>
    </Tooltip>
  );
}
